import { inject, Injectable } from '@angular/core';
import { SocketService } from '@core/services/socket.service';
import { ModalService } from '@features/modals/services/modal.service';

@Injectable({
  providedIn: 'root',
})
export class WithdrawService {
  private readonly socketService = inject(SocketService);
  private readonly modalService = inject(ModalService);

  constructor() {
    this.socketService.socket.on('withdraw_sent', (trade) => {
      this.modalService.openModal('WithdrawSentModal', {
        offerid: trade.offerid,
        hash: trade.hash,
        value: trade.value,
        skins: trade.skins,
        balancetype: trade?.balancetype,
      });
    });
  }
}
